import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 md:py-10 px-4 bg-brand-dark border-y border-white/5" data-id="element-73">
      <div className="max-w-2xl mx-auto text-center" data-id="element-74">
        <div className="inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-brand-accent rounded-full mb-4 shadow-[0_0_20px_rgba(0,191,255,0.4)]" data-id="element-75">
          <ShieldCheck className="w-7 h-7 md:w-8 md:h-8 text-brand-dark" data-id="element-76" />
        </div>

        <h2 className="text-lg md:text-2xl font-black mb-3 text-brand-accent neon-glow" data-id="element-77">
          🛡️ Garantía Kit Vóley Listo — 7 días
        </h2>

        <div className="text-sm md:text-base font-medium space-y-2 mb-4 text-gray-300" data-id="element-78">
          <p data-id="element-79">
            Abrís los 6 tomos. Revisás los 4 bonos. Los usás en tus clases si
            querés.
          </p>
          <p className="text-gray-500" data-id="element-80">Si en 7 días no es lo que esperabas:</p>
          <p className="text-xl md:text-2xl font-black text-brand-dark bg-brand-accent inline-block px-4 py-2 rounded-lg shadow-lg my-2" data-id="element-81">
            Te devolvemos el 100%
          </p>
          <p className="text-gray-500" data-id="element-82">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        <p className="text-xs text-gray-500 font-medium leading-relaxed" data-id="element-83">
          La confianza que tenemos en el Kit nos permite garantizarlo. Desde
          México hasta Argentina. Desde Colombia hasta Chile. El mismo
          compromiso para todos.
        </p>
      </div>
    </section>;
}